export const projets = [
      {
            nom_projet: 'Site Portfolio',
            langages: ['HTML', 'CSS', 'JavaScript', 'React'],
            annee: 2025,
            description:
                  "Il s'agit de mon premier projet personnel. Désireux d’être à la hauteur des attentes des différentes offres d’alternance, j’ai décidé de développer mon site en React, un framework que je n'avais pas encore étudié dans le cadre de mon cursus universitaire. Une implémentation d’une petite base de données avec Express et MongoDB est également prévue, ainsi qu’une initiation à Bootstrap pour la mise en forme en CSS est prévue à l'avenir.",
      },
      {
            url: 'gifinder',
            nom_projet: 'Application GiFinder',
            langages: ['Swift', 'XCode'],
            annee: 2025,
            description:
                  "Il s'agit d'une application mobile conçue avec le langage Swift, sous l'IDE Xcode. Réalisée en binôme dans le cadre d’un TD, celle-ci permet de rechercher et d’enregistrer des GIFs en fonction de mots-clés renseignés. Les GIFs sont récupérés à partir de l’API de Giphy.",
      },
      {
            url: 'planning_poker',
            nom_projet: 'Planning Poker',
            langages: ['JavaScript', 'NodeJs', 'Jest'],
            annee: 2025,
            description:
                  "Réalisé dans le cadre d’un TD, le site 'Planning Poker' reproduit l’une des pratiques d’estimation du temps utilisées dans les méthodes agiles Scrum. Ce projet, développé en binôme, a été codé en utilisant le Local Storage et testé à l’aide de tests unitaires avec la bibliothèque Jest de Node.js.",
      },
      {
            url: 'filtre_webcam',
            nom_projet: 'Filtres sur webcam',
            langages: ['Python'],
            annee: 2024,
            description:
                  'Réalisée dans le cadre d’un TD, cette petite application permet l’incrustation de filtres à partir de l’image captée par la webcam, grâce à la détection de visages à l’aide de la bibliothèque OpenCV en Python. Par souci de confidentialité, aucune vidéo n’est associée à ce projet. N’hésitez pas à en faire l’expérience vous-même !',
      },
      {
            url: 'moteur_recherche',
            nom_projet: 'Moteur de recherche',
            langages: ['Python'],
            annee: 2024,
            description:
                  'Ce projet, réalisé en binôme, consiste en la création d’un petit moteur de recherche. Les données ont été récupérées à partir des sources Reddit et ArXiv. Le frontend a été développé à l’aide de Jupyter Notebook.',
      },
      {
            url: 'site_theme_nba',
            nom_projet: 'Site thème NBA',
            langages: ['PHP', 'SQL'],
            annee: 2024,
            description:
                  "Il s'agit d'un projet universitaire mettant en place une architecture MVC avec le langage PHP. Le moteur de template TinyButStrong a été utilisé afin d’atteindre ce résultat. Une base de données, gérée via phpMyAdmin, a été mise en place pour structurer et accéder aux données.",
      },
      {
            url: 'site_theme_tennis',
            nom_projet: 'Site thème tennis',
            langages: ['HTML', 'PHP', 'SQL'],
            annee: 2024,
            description:
                  'Représentant mon tout premier projet dans le domaine du web, celui-ci a été une véritable initiation au développement web. Conçu sur le thème du tennis, il m’a permis de découvrir le langage PHP ainsi que les bases de données.',
      },
]
